import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentItemDriverMetricQuantityUpdateInput } from '../generated/globalTypes';
import { updateAssessmentItemDriverMetricQuantityMutation, updateAssessmentItemDriverMetricQuantityMutationVariables } from '../generated/updateAssessmentItemDriverMetricQuantityMutation';
import { assessmentItemDriverMetricQuantityFieldsFragment } from '../models/AssessmentItemDriverMetricQuantity';

/**
 * Get a callback to update a AssessmentItemDriverMetricQuantity in the store.
 */
export function useUpdateAssessmentItemDriverMetricQuantityCallback(): [(id: string, model: AssessmentItemDriverMetricQuantityUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateAssessmentItemDriverMetricQuantityMutation, updateAssessmentItemDriverMetricQuantityMutationVariables>(
        gql`
            mutation updateAssessmentItemDriverMetricQuantityMutation ($model: AssessmentItemDriverMetricQuantityUpdateInput!) {
                updateAssessmentItemDriverMetricQuantity(model: $model) {
                    ...assessmentItemDriverMetricQuantityFields
                }
            }

            ${assessmentItemDriverMetricQuantityFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: AssessmentItemDriverMetricQuantityUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
